import { render, staticRenderFns } from "./SpecialrequestPage.vue?vue&type=template&id=c6a1abb2&"
import script from "./SpecialrequestPage.vue?vue&type=script&lang=js&"
export * from "./SpecialrequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports